// extracted by mini-css-extract-plugin
export default {"main":"Layout_main__FxQfo","page":"Layout_page__ulGah"};